<!-- ChartModal.vue -->
<template>

  <div class="step" id="step-5">
        <div class="hora-form-step">

          <div  class="w-100 text-right hora-steps-text border-0">
            <div><p class="m-0">اطلاعات وارد شده را به دقت بررسی و بعد از تایید روی محاسبه بزنید.</p></div>
          </div>

          <div class="hora-form-container">
            <div class="profile-header">
              <div class="profile-image">
                <img :src=" site_url +  '/wp-content/plugins/hora-v2/statics/images/gravatar.png'" width="80"/>
              </div>
            </div>

            <!-- Information Section -->
            <div class="hora-form-information">
              <div class="info-field">
                <span class="info-label">نام:</span>
                <span class="info-value">{{ chartRequest.title }}</span>
              </div>

              <div class="info-field">
                <span class="info-label">جنسیت:</span>
                <span class="info-value">{{ genderText }}</span>
              </div>

              <div class="info-field">
                <span class="info-label">تاریخ تولد:</span>
                <span class="info-value">{{ chartRequest.year }}/{{ chartRequest.month }}/{{ chartRequest.day }}</span>
              </div>

              <div class="info-field">
                <span class="info-label">ساعت تولد:</span>
                <span class="info-value">{{ chartRequest.hour }}:{{ chartRequest.min }}</span>
              </div>

              <div class="info-field">
                <span class="info-label">شهر محل تولد:</span>
                <span class="info-value">{{ chartRequest.display_loc }}</span>
              </div>

              <div v-if="chartRequest.alert_text" class="info-field">
                <span class="info-value">{{ chartRequest.alert_text }}</span>
              </div>
            </div>
          </div>
        </div>

    <div class="hora-form-buttons">
      <a @click="$emit('previousStep')" class="back_btn" disabled>
        <span> بازگشت</span>
      </a>
      <a @click="$emit('submit-chart')" id="nextStep01" class="hora-calc-btn">
        <span>محاسبه</span>
      </a>
    </div>
  </div>
</template>

<script>


import HelperLib from "./helper";


export default {
  name: 'ChartModal',
  props: {
    chartRequest: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      site_url: null,
    };
  },
  mounted() {
    this.site_url = process.env.BASE_URL;
  },
  computed: {
    genderText() {
      switch (this.chartRequest.gender) {
        case "0":
          return 'زن';
        case "1":
          return 'مرد';
        case "2":
          return 'they';
        default:
          return '';
      }
    }
  }
};
</script>

<style>

.hora-form-container {
  width: 100%;
}


.profile-header {
  background-color: #A4B4CB;
  height: 62px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -20px;
  margin-right: -10px;
  width: calc(100% + 20px);
}


.profile-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}


.hora-form-information {
  padding: 20px 0px 20px 0px;
  background-color: #ffffff;
  display: flex;
  gap: 21px;
  flex-direction: column;
}


.info-field {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 6px 7px 6px 3px;
  background: #F3F3F3;
  min-height: 40px;
  height: auto;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
}


.info-field:last-child {
  border-bottom: none;
}


.info-label {
  font-weight: bold;
  color: #475569;
  font-size: 14px;
}

/* Values for the fields */
.info-value {
  color: #1e293b; /* Darker slate */
  font-size: 14px;
  text-align: right;
}

</style>
